/**
 * @Author: Zewei
 * @Date:   2018-02-01T10:26:44+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-28T10:45:08+08:00
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { exportEmployeesMonthlyReportDetail, fetchEmployeesReviewList } from '../../actions/employee-management-actions.js';
import { Table, Divider, Button, Modal, Spin } from 'antd';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import './style.less';

const { confirm } = Modal;

const mapStateToProps = state => ({
   employeeManagement: state.employeeManagement,
 });
const mapDispatchToProps = { exportEmployeesMonthlyReportDetail, fetchEmployeesReviewList };

 @connect(mapStateToProps, mapDispatchToProps)
 class EmployeesReview extends Component {
     state = {
       selectedRowKeys: [], // Check here to configure the default column
     }

     columns = [{
        title: '姓名',
        dataIndex: 'real_name',
        key: 'real_name',
      }, {
         title: '工号',
         dataIndex: 'job_number',
         key: 'job_number'
       }, {
         title: '证件号',
         dataIndex: 'id_number',
         key: 'id_number',
       }, {
         title: '当前合同终止日',
         dataIndex: 'contract_end_date',
         key: 'birthcontract_end_date',
       }, {
         title: '试用期到期日',
         dataIndex: 'probation_end_date',
         key: 'probation_end_date',
       }, {
         title: '英文名',
         dataIndex: 'english_name',
         key: 'english_name',
       }
    ]

     componentDidMount() {
         this._formatUrlParams()
     }

     _formatUrlParams = () => {
         let { pathname } = window.location,
             lastSlashIndex = pathname.lastIndexOf('/'),
             truncateUrl = pathname.slice(lastSlashIndex+1),
             urlParamsArray = truncateUrl.split('&'),
             DepartmentId, MonthlyReportType, Year, Month,
             fetchEmployeesParams;

        urlParamsArray.forEach(i => {
                 if (i.indexOf('DepartmentId') !== -1) {
                     let idx = i.indexOf('=');
                     DepartmentId = parseInt(i.slice(idx + 1), 10);
                 }
                 if (i.indexOf('MonthlyReportType') !== -1) {
                     let idx = i.indexOf('=');
                     MonthlyReportType = parseInt(i.slice(idx + 1), 10);
                 }
                 if (i.indexOf('Year') !== -1) {
                     let idx = i.indexOf('=');
                     Year = i.slice(idx + 1);
                 }
                 if (i.indexOf('Month') !== -1) {
                     let idx = i.indexOf('=');
                     Month = i.slice(idx + 1)
                 }
             })

         fetchEmployeesParams = {
             DepartmentId,
             MonthlyReportType,
             Year,
             Month
         }
        this.setState({
            fetchEmployeesParams
        })
        // 根据 url 参数 调用 Employess 列表
        this._fetchEmployeesReviewList(fetchEmployeesParams)
     }

     _fetchEmployeesReviewList = (params) => {
         let { fetchEmployeesParams } = this.state;
         params = {...fetchEmployeesParams, ...params};
         this.props.fetchEmployeesReviewList(params)
     }
     _fetchEmployeeInit = () => {
         this.props.fetchEmployeeInit()
     }

     onSelectChange = (selectedRowKeys, selectedRows) => {
         this.setState({ selectedRowKeys });
     }

     componentWillReceiveProps(nextProps) {
         const { monthlyReportDetailFileUrl } = nextProps.employeeManagement;
         monthlyReportDetailFileUrl && window.open(monthlyReportDetailFileUrl);
     }

     handleExport = () => {
         // this.props.exportEmployees()
         confirm({
           title: '确定导出?',
           okText: '确认',
           cancelText: '取消',
           onOk: () => {
             this.props.exportEmployeesMonthlyReportDetail(this.state.fetchEmployeesParams)
           },
           onCancel: () => {}
         })
     }

     goBack = () => {
         window.history.back()
     }

     render() {
         const { employeesReviewList } = this.props.employeeManagement;
         const { selectedRowKeys } = this.state;
         const rowSelection = {
           selectedRowKeys,
           onChange: this.onSelectChange,
         };

           let paginationCfg;

           if (employeesReviewList) {
               paginationCfg = {
                   current: employeesReviewList.Page,
                   total: employeesReviewList.Total,
                   pageSize: employeesReviewList.PageSize,
                   onChange: (page) => {
                       this._fetchEmployeesReviewList({page})
                   }
               }
           }

         return (
             <section className="app-module-item">
                 <div className="colAction">
                     <Button type="primary" icon="arrow-left" onClick={this.goBack}>返回</Button>
                     <Divider type="vertical" />
                     <Button type="primary" icon="cloud-download-o" onClick={this.handleExport}>导出</Button>
                 </div>
                 {
                     employeesReviewList ?
                          <Table
                             columns={this.columns}
                             dataSource={employeesReviewList.Data}
                             rowSelection={rowSelection}
                             rowKey={record => `${record.id}`}
                             scroll={{ x: 1000 }}
                             pagination={paginationCfg}
                          />
                           :
                          <Spin className="spin-center" />
                 }
             </section>
         )
     }
 }

EmployeesReview = LayoutWrapper(EmployeesReview)

export default EmployeesReview;



// WEBPACK FOOTER //
// ./src/routes/EmployeeManagement/EmployeesReview.js